const TFD_PIXEL_ID = '3d164ba1-652e-4c56-92a8-522db2a5f9e2';
const FIRSTMEDIA_PIXEL_ID = '3044af98-0b74-4368-9549-ebe08b7ed1d6';

export const PIXEL_IDS = [TFD_PIXEL_ID, FIRSTMEDIA_PIXEL_ID];
